(() => {
  if (customElements.get('rocket-crew-signup')) return;
  customElements.define('rocket-crew-signup', class extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('iframe');
      if (!this.frame || this.onMessage) return;
      const origin = new URL(this.frame.src).origin;
      this.onMessage = (event) => {
        if (event.source !== this.frame.contentWindow || event.origin !== origin) return;
        const rawHeight = event.data?.height;
        if (typeof rawHeight !== 'number' && typeof rawHeight !== 'string') return;
        const value = String(rawHeight).trim();
        if (!/^\d+(?:\.\d+)?(?:px)?$/.test(value)) return;
        const height = Number.parseFloat(value);
        if (!Number.isFinite(height) || height <= 0) return;
        this.style.setProperty('--crew-signup-measured-height', Math.min(6000, Math.max(320, Math.ceil(height))) + 'px');
      };
      window.addEventListener('message', this.onMessage);
    }
    disconnectedCallback() {
      if (this.onMessage) window.removeEventListener('message', this.onMessage);
      this.onMessage = null;
    }
  });
})();
